import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

//
import { Card, Form, Button, Spinner } from "react-bootstrap";

//
import PageHeader from "../general/PageHeader";
import CoinTypeDropdown from "../general/CoinTypeDropdown";
import TimeRangeDropdown from "../general/TimeRangeDropdown";

//
import { Formik } from "formik";
import * as yup from "yup";

const schema = yup.object().shape({
  coin: yup.object().shape({
    id: yup.number().required(),
    key: yup.string().required(),
    name: yup.string().required(),
    status: yup.string().required(),
    symbol: yup.string().required(),
  }).required(),
  time: yup.object().shape({
    name: yup.string().required(),
    value: yup.object().shape({
      start: yup.string().required(),
      end: yup.string().required(),
    }),
  }).required(),
});

function Forms({
  coins,
  activeCoin,
  setActiveCoin,
  loading,
  timeRanges,
  timeRange,
  setTimeRange,
  getCoinInfo,
}) {
  const [boxHeight, setBoxHeight] = useState(0);

  const [initialValues, setInitialValues] = useState({
    coin: {},
    time: {},
  });

  const updateValues = (name, value) => {
    if (name === "time") {
      setTimeRange(value);
    } else {
      setActiveCoin(value);
    }
    let values = { ...initialValues };

    values[name] = value;

    setInitialValues(values);
  };

  useEffect(() => {
    let main = document.getElementById("alert-report");
    let header = document.getElementsByClassName("page-header")[0];

    //
    setBoxHeight(main.clientHeight - header.clientHeight);
    const handleResizeWindow = () =>
      setBoxHeight(main.clientHeight - header.clientHeight);

    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
  }, []);

  return (
    <>
      <PageHeader title="Alerts Report" subject="Alerts history of all coins" />

      <Card style={{ height: `${boxHeight}px` }} className="forms">
        <Card.Body>
          <h5 className="text-center">
            Find crypto alert history by time range
          </h5>
          <p className="text-center">
            You have {coins.length} active coins, access alert reports by input
            in below
          </p>

          <Formik
            validationSchema={schema}
            enableReinitialize
            onSubmit={getCoinInfo}
            initialValues={initialValues}
          >
            {({ handleSubmit, handleChange, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                
                <div className="filter">
                  <TimeRangeDropdown
                    filters={timeRanges}
                    activeFilter={timeRange}
                    action={(item) => updateValues("time", item)}
                    full
                    fit
                    align="start"
                    isInvalid={touched.time && !!errors.time}
                  />

                  <CoinTypeDropdown
                    filters={coins}
                    activeFilter={activeCoin}
                    action={(item) => updateValues("coin", item)}
                    title="Crypto Coins"
                    full
                    fit
                    align="start"
                    coin
                    isInvalid={touched.coin && !!errors.coin}
                  />

                  <Button variant="info" type="submit">
                    Show Reports
                    {loading && (
                      <div className="spinner-holder">
                        <Spinner animation="border" variant="white" size="sm" />
                      </div>
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </>
  );
}

Forms.propTypes = {
  coins: PropTypes.array.isRequired,
  activeCoin: PropTypes.object.isRequired,
  setActiveCoin: PropTypes.func.isRequired,

  loading: PropTypes.bool.isRequired,

  timeRanges: PropTypes.array.isRequired,
  timeRange: PropTypes.object.isRequired,
  setTimeRange: PropTypes.func.isRequired,

  getCoinInfo: PropTypes.func.isRequired,
};

export default Forms;
